import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { injectIntl, FormattedMessage } from 'react-intl';
import { CSVLink } from 'react-csv';
import getSymbolFromCurrency from 'currency-symbol-map';

import { csvExportLabels as messages } from '../messages';

const FooterContainer = styled.div`
    padding: 5px;
    padding-top: 15px;
    text-align: left;

    a {
        font-size: 12px;
        color: inherit;
    }
`;

const Footer = ({ data, currency, intl }) => {
    const filename = `${intl.formatMessage(messages.exportedFileName)}.csv`;
    const formatRooms = (value) => {
        if (value === null) return null;
        return intl.formatNumber(value);
    };
    const formatRevenue = (value) => {
        if (value === null) return null;
        const currencySymbol = getSymbolFromCurrency(currency);
        const currencyValue = intl.formatNumber(value / 100, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

        return `${currencySymbol}${currencyValue}`;
    };

    const exportData = [
        { key: 'current', showUnguaranteed: true },
        { key: 'lySpit', showUnguaranteed: true },
        { key: 'lySpitVariance', showUnguaranteed: true },
        { key: 'lyFinal', showUnguaranteed: false },
        { key: 'lyFinalVariance', showUnguaranteed: false },
        { key: 'y2Spit', showUnguaranteed: true },
        { key: 'y2SpitVariance', showUnguaranteed: true },
        { key: 'y2Final', showUnguaranteed: false },
        { key: 'y2FinalVariance', showUnguaranteed: false },
    ].map(({ key, showUnguaranteed }) => {
        const rooms = {
            guaranteed: data[key].rooms.guaranteed,
            nonGuaranteed: showUnguaranteed ? data[key].rooms.nonGuaranteed : null,
        };
        const revenue = {
            guaranteed: data[key].revenue.accommodation.guaranteed,
            nonGuaranteed: showUnguaranteed ? data[key].revenue.accommodation.nonGuaranteed : null,
        };
        return {
            label: intl.formatMessage(messages[`${key}RowLabel`]),
            rooms: {
                guaranteed: formatRooms(rooms.guaranteed),
                nonGuaranteed: formatRooms(rooms.nonGuaranteed),
                total: formatRooms(rooms.guaranteed + (rooms.nonGuaranteed || 0)),
            },
            revenue: {
                guaranteed: formatRevenue(revenue.guaranteed),
                nonGuaranteed: formatRevenue(revenue.nonGuaranteed),
                total: formatRevenue(revenue.guaranteed + (revenue.nonGuaranteed || 0)),
            },
        };
    });
    const headers = [
        {
            label: '',
            key: 'label',
        },
        {
            label: intl.formatMessage(messages.guaranteedRoomsColumn),
            key: 'rooms.guaranteed',
        },
        {
            label: intl.formatMessage(messages.nonGuaranteedRoomsColumn),
            key: 'rooms.nonGuaranteed',
        },
        {
            label: intl.formatMessage(messages.totalRoomsColumn),
            key: 'rooms.total',
        },
        {
            label: intl.formatMessage(messages.guaranteedRevenueColumn),
            key: 'revenue.guaranteed',
        },
        {
            label: intl.formatMessage(messages.nonGuaranteedRevenueColumn),
            key: 'revenue.nonGuaranteed',
        },
        {
            label: intl.formatMessage(messages.totalRevenueColumn),
            key: 'revenue.total',
        },
    ];

    return (
        <FooterContainer>
            <CSVLink headers={headers} data={exportData} filename={filename}>
                <FormattedMessage {...messages.exportLink} />
            </CSVLink>
        </FooterContainer>
    );
};

Footer.propTypes = {
    data: PropTypes.object.isRequired, // see main widget
    currency: PropTypes.string.isRequired, // see main widget
    // From react-intl
    intl: PropTypes.object.isRequired,
};

export default injectIntl(Footer);
